<template>
  <div>
    <div class="inputWithLabel" :class="{ isPc: !isSp }">
      <InputLabel
        v-if="hasLabel"
        class="labelArea"
        :class="{ isPc: !isSp, isHasLabel: !isSp && (required || optional) }"
        :required="required"
        :optional="optional"
        :right-space="rightSpace"
      >
        {{ areaLabel }}
      </InputLabel>
      <div class="passwordWrapper">
        <InputItem
          v-model="handlePassword"
          :input-type="inputType"
          :placeholder-value="placeholder"
          :maxlength="maxlength"
          class="inputItem"
          :class="{ hasError: hasError, isPc: !isSp, isLoginPage: isLoginPage }"
          @blur="onBlur"
        />
        <span class="passwordMask" :class="{ isInvisible: isInvisible }" @click="togglePassword"
          ><img src="/images/contents/visible.svg"
        /></span>
      </div>
    </div>
    <div class="underInputArea" :class="{ isPc: !isSp, isNoLabel: !isSp && !(required || optional) }">
      <PartialErrorMessage :is-sp-flg="true" :error="displayError" class="partialErrorComponent" />
    </div>
  </div>
</template>

<script>
import InputLabel from '../Text/InputLabel.vue';
import InputItem from './InputItem.vue';
import PartialErrorMessage from '../PartialErrorMessage.vue';
import { GENERAL_VALIDATION_MESSAGE } from '../../../../helper/_validationCheckMessages';

export default {
  name: 'Password',
  components: {
    InputLabel,
    InputItem,
    PartialErrorMessage,
  },
  model: {
    prop: 'inputValue',
    event: 'change',
  },
  props: {
    areaLabel: {
      type: String,
      required: false,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: '',
    },
    /**
     * 外部からのエラー
     * このコンポーネントに定義しないような独自のバリデーションを持つ場合、
     * 親コンポーネントでv-modelの値をwatchとかしてバリデーションチェックを行い、
     * errorFromOuterにpropsで渡すと、最後の項目としてチェック入る。
     * 空文字・undefinedを渡すことで『エラー無し』扱いになる。
     */
    errorFromOuter: {
      type: String,
      required: false,
      default: '',
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    optional: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    rightSpace: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    inputValue: {
      type: String,
      required: false,
      default: '',
    },
    maxlength: {
      type: String,
      required: false,
      default: '',
    },
    isLoginPage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      validationError: undefined,
      // パスワードの表示/非表示フラグ
      isInvisible: true,
    };
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
    hasLabel() {
      return this.areaLabel;
    },
    displayError() {
      if (this.validationError) return this.validationError;
      return this.errorFromOuter;
    },
    hasError() {
      // displayError自体がundefinedならエラーない
      if (!this.displayError) return false;
      // displayError自体がlengthもってるならエラーあり
      if (this.displayError.length) return true;
      return false;
    },
    handlePassword: {
      get() {
        return this.inputValue;
      },
      set(value) {
        this.$emit('change', value);
      },
    },
    inputType() {
      return this.isInvisible ? 'password' : 'text';
    },
  },
  methods: {
    onBlur() {
      this.validationError = this.handlePassword === '' ? `パスワード${GENERAL_VALIDATION_MESSAGE.EMPTY}` : undefined;
      this.$emit('watchValidation', !!this.validationError);
    },
    togglePassword() {
      this.isInvisible = !this.isInvisible;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.inputWithLabel {
  .labelArea.isPc {
    width: 120px;
    margin: auto 0;
    flex-shrink: 0;

    &.isHasLabel {
      width: 184px;
    }
  }

  .passwordWrapper {
    position: relative;
    display: flex;
    align-items: center;

    .inputItem {
      &.isPc {
        width: 432px;

        &.isLoginPage {
          width: 316px;
        }
      }

      &::-ms-reveal {
        display: none;
      }
    }

    .passwordMask {
      color: #d3d4d4;
      position: absolute;
      right: 8px;
      width: 24px;
      height: 24px;
      top: 12px;
      bottom: 12px;

      &.isInvisible::before {
        display: block;
        content: '';
        width: 24px;
        height: 2px;
        background: #d3d4d4;
        position: absolute;
        top: 11px;
        right: 0;
        transform: rotate(-45deg);
      }
    }
  }

  &.isPc {
    display: flex;
  }
}

.underInputArea {
  &.isPc {
    margin-left: 184px;
  }

  &.isNoLabel {
    margin-left: 120px;
  }
}

.inputItem.hasError,
.inputItem.hasError:focus {
  border: $border-alert;
}

.partialErrorComponent {
  margin-top: 8px;
}
</style>
